export const formatDate = (date, format) => {
    if (!date) return '';
    const dateObj = new Date(date);
    
    if (format) {
      // If specific format is requested
      return dateObj.toLocaleString();
    }
    
    return dateObj.toLocaleString();
  };
  
  export const formatSingleActions = (action) => {
    if (!action) return '';
    
    switch (action.field) {
      case 'tags':
        return `${action.field} "${action.tagsChanged}"`;
      default:
        return `changed ${action.field} from "${action.valueBefore}" to "${action.valueAfter}"`;
    }
  };
  
  export const formatBulkActions = (action) => {
    if (!action) return '';
    
    switch (action.action) {
      case 'clearComment':
      case 'tickTax':
      case 'untickTax':
        return formatCamelCaseToWords(action.action);
      default:
        return `${formatCamelCaseToWords(action.action)} "${action.value}"`;
    }
  };
  
  export const formatFilters = (filters) => {
    if (!filters) return '';
    
    const changedFilters = [];
    
    // Only include filters that are different from default values
    if (filters.searchText) changedFilters.push(`search: "${filters.searchText}"`);
    if (filters.tags?.length > 0) changedFilters.push(`tags: [${filters.tags.join(', ')}]`);
    if (filters.description) changedFilters.push(`description: "${filters.description}"`);
    if (filters.description2) changedFilters.push(`description2: "${filters.description2}"`);
    if (filters.comments) changedFilters.push(`comments: "${filters.comments}"`);
    if (filters.filterStartDate && formatDate(filters.filterStartDate) !== formatDate(filters.minDate)) {
      changedFilters.push(`start date: ${new Date(filters.filterStartDate).toLocaleDateString()}`);
    }
    if (filters.filterEndDate && formatDate(filters.filterEndDate) !== formatDate(filters.maxDate)) {
      changedFilters.push(`end date: ${new Date(filters.filterEndDate).toLocaleDateString()}`);
    }
    if (filters.filterMinAmount !== filters.minAmount) changedFilters.push(`min amount: ${filters.filterMinAmount}`);
    if (filters.filterMaxAmount !== filters.maxAmount) changedFilters.push(`max amount: ${filters.filterMaxAmount}`);
    if (!filters.tax.true) changedFilters.push('hide tax');
    if (!filters.tax.false) changedFilters.push('hide non-tax');
    if (filters.showUntagged) changedFilters.push('show untagged only');
  
    return changedFilters.join(', ');
  };
  
  export const formatHistoryEntry = (entry) => {
    if (!entry) return '';
    
    switch (entry.type) {
      case 'single':
        return `${entry.userEmail} ${formatSingleActions(entry.action)} on transaction: [Date: ${entry.rowData.date}, Amount: ${entry.rowData.amount}, Description: ${entry.rowData.description} ${entry.rowData.description2 && entry.rowData.description2.length > 0 ? ", Description2: "+entry.rowData.description2 : ""}]`;
      case 'bulk':
        return `${entry.userEmail} performed bulk change: ${formatBulkActions(entry.action)} with Filters: ${formatFilters(entry.filters)}, on ${entry.affectedRows} transactions`;
      case 'rule':
        return `${entry.userEmail} applied rule: ${entry.ruleName}, on ${entry.affectedRows} transactions`;
      default:
        return JSON.stringify(entry);
    }
  };

  export const formatRuleName = (filters, actions) => {
    if (!actions || actions.length === 0) return '';
    
    // Format all actions
    const actionsText = actions
      .map(action => formatBulkActions(action))
      .join(' & ');
  
    // Format filters if they exist
    const filtersText = filters ? formatFilters(filters) : '';
    
    // Combine actions with filters
    if (filtersText) {
      return `${actionsText} with Filters: ${filtersText}`;
    }
    
    return actionsText;
  };

  export const formatCamelCaseToWords = (text) => {
    if (!text) return '';
    
    // Handle special cases like 'clearComment' -> 'Clear Comment'
    return text
      // Split on capital letters
      .split(/(?=[A-Z])/)
      // Join with space and capitalize first letter
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };